
import React from "react";
import { 
  Card, 
  CardContent, 
  CardHeader, 
  CardTitle, 
  CardDescription 
} from "@/components/ui/card";
import { UserCheck } from "lucide-react";

interface TherapistWithConnections {
  id: string;
  name: string;
  connectionCount: number;
}

interface TherapistConnectionsTableProps {
  therapistsWithConnections: TherapistWithConnections[];
}

const TherapistConnectionsTable = ({ therapistsWithConnections }: TherapistConnectionsTableProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <UserCheck className="mr-2 h-5 w-5 text-[#333B44]" />
          Therapists by Active Connections
        </CardTitle>
        <CardDescription>
          Therapists ranked by number of connected clients
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[300px] overflow-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left p-2">Rank</th>
                <th className="text-left p-2">Therapist Name</th>
                <th className="text-right p-2">Active Clients</th>
              </tr>
            </thead>
            <tbody>
              {therapistsWithConnections.length === 0 ? (
                <tr>
                  <td colSpan={3} className="text-center p-4 text-[#5A636E]">
                    No active therapist connections found
                  </td>
                </tr>
              ) : (
                therapistsWithConnections.map((therapist, index) => (
                  <tr key={therapist.id} className="border-b">
                    <td className="p-2">{index + 1}</td>
                    <td className="p-2">{therapist.name}</td>
                    <td className="p-2 text-right">{therapist.connectionCount}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};

export default TherapistConnectionsTable;
